import { getMark } from '@atlassian/jira-common-performance';
import { SPA_SSR_RENDERED } from '@atlassian/jira-providers-spa-apdex-analytics/src/constants';

export const getSSRMark = () => getMark(SPA_SSR_RENDERED)?.startTime || null;
